/**
 * Render FullCalendar resource label with duration and optional amplitude
 * @param {{title: string, duration: string, amplitude: string | null}} arg
 * @returns {JSX.Element}
 */
function renderCalendarResourceLabel(arg) {
  const { title, duration, amplitude } = arg;
  return (
    <div>
      <div>
        {title}
      </div>
      <div style={{ fontSize: '0.85em', color: '#666', marginTop: '4px' }}>
        <p>{`Durée: ${duration}`}</p>
        {amplitude && (
          <p>{`Amplitude: ${amplitude}`}</p>
        )}
      </div>
    </div>
  );
}

export default renderCalendarResourceLabel;
